/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../../Component/Pagination/Pagination'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import {message, Table} from 'antd'
import $ from 'jquery'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'
import MyDatePicker from '../BaseComponent/DatePicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'

class Version extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      version: [],
      printInfo: [],
      fromDate: jMoment().format('jYYYY/jMM/jDD'),
      toDate: '',
      modalDelete: false,
      sortLabel: []
    }
  }

  getAllAppVersion = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    sortBy = sessionStorage.getItem('sortBy')
  ) => {
    http
      .get(
        `${
          BASE_REPORT.BASE_REPORT_APPVERSION
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}&sortBy=${sortBy}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable').fadeIn()

          this.setState({
            version: response.data.object.result,
            lengthProducts: response.data.object.countAll
          })
        } else {
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description);
          $('.showBaseTable').fadeOut()
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    sessionStorage.setItem('sortBy', 'releaseTime_desc')
    this.getAllAppVersion()
  }

  filter() {
    var type = $('#type').val()
    var force = $('#force').val()
    var stable = $('#stable').val()
    var version = $('#version').val()
    var releaseMin = this.state.fromDate
    var releaseMax = this.state.toDate

    sessionStorage.setItem(
      'params',
      `type=${type}&version=${version}&stable=${stable}&force=${force}&releaseMin=${
        releaseMin == null ? '' : releaseMin
      }&releaseMax=${releaseMax == null ? '' : releaseMax}`
    )
    sessionStorage.setItem('pageNumber', 1)
    this.getAllAppVersion()
  }

  onResultFetched(data) {
    this.setState({
      version: data
    })
  }

  changeDropDown(data) {
    this.setState({
      version: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  changeSort(data, sortLabel) {
    this.setState({
      sortLabel,
      version: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  exportExcel = () => {
    http
      .get(
        `${BASE_REPORT.BASE_REPORT_APPVERSION}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['release'] = jMoment(excelReport[i]['release']).format('jYY/jMM/jDD')

            if (excelReport[i]['type'] == '200') {
              excelReport[i]['type'] = 'مشتری'
            } else {
              excelReport[i]['type'] = 'رساننده'
            }
            if (excelReport[i]['stable']) {
              excelReport[i]['stable'] = 'با ثبات'
            } else {
              excelReport[i]['stable'] = 'بی ثبات'
            }

            if (excelReport[i]['force']) {
              excelReport[i]['force'] = 'اجباری'
            } else {
              excelReport[i]['force'] = 'اختیاری'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${BASE_REPORT.BASE_REPORT_APPVERSION}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  activate = (enabled, id) => {
    if (enabled) {
      let data = {
        id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_DISABLE_APPVERSION}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllAppVersion()
          } else {
            // message.error('عملیات تغییر وضعیت نوع پرداخت موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      let data = {
        id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_ENABLE_APPVERSION}`, data, {})
        .then((response) => {
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            this.getAllAppVersion()
          } else {
            // message.error('عملیات تغییر وضعیت نوع پرداخت موفق نبود')
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteVersion = (versionId, versionName) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      versionId,
      versionName
    })
  }

  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      versionId: '',
      versionName: ''
    })
  }

  deleteOk = () => {
    let data = {
      id: this.state.versionId
    }
    http
      .post(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_DELETE_APPVERSION}`, data, {})
      .then((response) => {
        if (response.data.error === null) {
          this.getAllAppVersion()

          message.success('ورژن با موفقیت حذف شد')
          this.setState({
            modalDelete: !this.state.modalDelete,
            versionId: '',
            versionName: ''
          })
        } else {
          // message.error(JSON.stringify('خطای ' + response.data.errorCode + ' : ' + response.data.description));
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')

    let sortParams = [
      {title: 'تاریخ انتشار - صعودی', value: 'releaseTime_asc'},
      {title: 'تاریخ انتشار - نزولی', value: 'releaseTime_desc'}
    ]

    let printCol = ['ردیف', 'نوع', 'کد', 'نسخه', 'تاریخ انتشار', 'وضعیت ثبات', 'وضعیت دانلود']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش نسخه های اپلیکیشن"
              headerColSpan={7}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((version, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{version.type == '200' ? 'مشتری' : 'رساننده'}</td>
                  <td>{version.code}</td>
                  <td>{version.version}</td>
                  <td>{jMoment(version.releaseTime).format('jYYYY/jM/jD  HH:mm:ss')}</td>
                  <td>{version.stable ? 'با ثبات' : 'بی ثبات'}</td>
                  <td>{version.force ? 'اجباری' : 'اختیاری'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش نسخه های اپلیکیشن.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'type'}
                field={'type'}
                title={'نوع'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'code'}
                field={'code'}
                title={'کد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'version'}
                field={'version'}
                title={'نسخه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'release'}
                field={'release'}
                title={'تاریخ انتشار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'stable'}
                field={'stable'}
                title={'وضعیت ثبات'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'force'}
                field={'force'}
                title={'وضعیت دانلود'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>نسخه های اپلیکیشن</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/addVersion"
                  sort={true}
                  url={BASE_REPORT.BASE_REPORT_APPVERSION}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  changeSort={this.changeSort.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  titleAdd="افزودن ورژن"
                  sortParams={sortParams}
                  execelUrl={BASE_REPORT.BASE_REPORT_APPVERSION + '?export=true'}
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="filterComponent">
              <div className="filterInputs">
                <MyDatePicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  limitToDate={false}
                  setDefaultValue={false}
                  fromId="releaseMin"
                  toId="releaseMax"
                  fromLabel="تاریخ انتشار از"
                  toLabel="تاریخ انتشار تا"
                />

                <div className="formComponent">
                  <label>نوع</label>
                  <select className="form-control" id="type">
                    <option value="">------</option>
                    <option value="customer">مشتری</option>
                    <option value="driver">رساننده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت دانلود</label>
                  <select className="form-control" id="force">
                    <option value="">------</option>
                    <option value={1}>اجباری</option>
                    <option value={0}>اختیاری</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>وضعیت ثبات</label>
                  <select className="form-control" id="stable">
                    <option value="">------</option>
                    <option value={1}>با ثبات</option>
                    <option value={0}>بی ثبات</option>
                  </select>
                </div>
                <div className="formComponent">
                  <label>ورژن</label>
                  <input className="form-control" id="version" type="number" min="1" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr>
                    <td>ردیف</td>
                    <td>نوع</td>
                    <td>کد</td>
                    <td>نسخه</td>
                    <td>تاریخ انتشار</td>
                    <td>وضعیت ثبات</td>
                    <td>وضعیت دانلود</td>
                    <td>لینک دانلود</td>
                    <td>فعال</td>
                    <td>ویرایش</td>
                    <td>ویرایش فایل</td>
                    <td>حذف</td>
                  </tr>
                  {this.state.version.map((version, index) => (
                    <tr>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{version.type == '200' ? 'مشتری' : 'رساننده'}</td>
                      <td>{version.code}</td>
                      <td>{version.version}</td>
                      <td>{jMoment(version.releaseTime).format('jYYYY/jM/jD  HH:mm')}</td>
                      <td>{version.stable ? 'با ثبات' : 'بی ثبات'}</td>
                      <td>{version.force ? 'اجباری' : 'اختیاری'}</td>
                      <td>
                        <a
                          href={version.url}
                          target="_blank"
                          style={version.url == null ? {visibility: 'hidden'} : {visibility: 'visible'}}
                        >
                          <img className="btnImage" src={require('../../image/download.svg')} alt="" />
                        </a>
                      </td>
                      <td>
                        <button onClick={() => this.activate(version.enabled, version.id)}>
                          {version.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <Link to={`/EditVersion/${version.id}`}>
                          <img className="btnImage" src={require('../../image/editDriver.svg')} alt={''} />
                        </Link>
                      </td>
                      <td>
                        <Link to={`/EditVersionFile/${version.id}`}>
                          <img className="btnImage" src={require('../../image/editDriver.svg')} alt={''} />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.deleteVersion(version.id, version.version)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/*<p>مرتب سازی بر اساس : </p>*/}
              {/*<ul className='badgeSort'>*/}
              {/*{this.state.sortLabel.map((item,index)=>(*/}
              {/*<li className='badge badge-primary' key={index}>{item}</li>*/}
              {/*))}*/}
              {/*</ul>*/}

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.lengthProducts}
                  urlParams={sessionStorage.getItem('params')}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={BASE_REPORT.BASE_REPORT_APPVERSION}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
          <ModalHeader toggle={this.deleteCancel}>حذف ورژن</ModalHeader>
          <ModalBody>
            <p className="titleSm">از حذف ورژن {this.state.versionName} مطمئن هستید ؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف ورژن
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default Version
